import {Audio} from 'interfaces';

import {createAction} from '@reduxjs/toolkit';

export interface YouTubeSignInResponse {
  accessToken: string;
  tokenTimestamp?: number;
}

export interface YoutubeUploadPayload {
  audio: Audio;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export interface YouTubeSignInPayload {
  onSuccess?: (data: YouTubeSignInResponse) => void;
  onError?: (error: string) => void;
}

export interface YouTubeSignOutPayload {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export interface RefreshYouTubeTokenPayload {
  onSuccess?: (data: YouTubeSignInResponse) => void;
  onError?: (error: string) => void;
}

export const signInYouTube = createAction<YouTubeSignInPayload | undefined>(
  'youtube/signIn',
);
export const signInYouTubeSuccess = createAction<YouTubeSignInResponse>(
  'youtube/signInSuccess',
);
export const signInYouTubeFailure = createAction<string>(
  'youtube/signInFailure',
);

export const signOutYouTube = createAction<YouTubeSignOutPayload | undefined>(
  'youtube/signOut',
);
export const signOutYouTubeSuccess = createAction('youtube/signOutSuccess');
export const signOutYouTubeFailure = createAction<string>(
  'youtube/signOutFailure',
);

export const resetYouTubeState = createAction('ResetYouTubeState');

export const uploadToYoutube =
  createAction<YoutubeUploadPayload>('youtube/upload');
export const uploadToYoutubeSuccess = createAction<any>(
  'youtube/uploadSuccess',
);
export const uploadToYoutubeFailure = createAction<string | any>(
  'youtube/uploadFailure',
);

// Actions for token refresh
export const refreshYouTubeToken = createAction<
  RefreshYouTubeTokenPayload | undefined
>('youtube/refreshToken');
export const refreshYouTubeTokenSuccess = createAction<YouTubeSignInResponse>(
  'youtube/refreshTokenSuccess',
);
export const refreshYouTubeTokenFailure = createAction<string>(
  'youtube/refreshTokenFailure',
);
